// This file is generated automatically by scripts/build/cssToTs/cssToTs.ts, please don't edit.
export const spacingTokenByValue = {
    "1v": "0.25rem",
    "1w": "0.5rem",
    "2v": "0.5rem",
    "3v": "0.75rem",
    "2w": "1rem",
    "4v": "1rem",
    "5v": "1.25rem",
    "3w": "1.5rem",
    "6v": "1.5rem",
    "7v": "1.75rem",
    "4w": "2rem",
    "8v": "2rem",
    "9v": "2.25rem",
    "10v": "2.5rem",
    "5w": "2.5rem",
    "11v": "2.75rem",
    "12v": "3rem",
    "6w": "3rem",
    "13v": "3.25rem",
    "14v": "3.5rem",
    "7w": "3.5rem",
    "15v": "3.75rem",
    "16v": "4rem",
    "8w": "4rem",
    "17v": "4.25rem",
    "18v": "4.5rem",
    "9w": "4.5rem",
    "19v": "4.75rem",
    "10w": "5rem",
    "20v": "5rem",
    "21v": "5.25rem",
    "11w": "5.5rem",
    "22v": "5.5rem",
    "23v": "5.75rem",
    "12w": "6rem",
    "24v": "6rem",
    "25v": "6.25rem",
    "13w": "6.5rem",
    "26v": "6.5rem",
    "27v": "6.75rem",
    "14w": "7rem",
    "28v": "7rem",
    "29v": "7.25rem",
    "15w": "7.5rem",
    "30v": "7.5rem",
    "31v": "7.75rem",
    "16w": "8rem",
    "32v": "8rem"
};
//# sourceMappingURL=spacing.js.map